import { render, staticRenderFns } from "./MobileContactPersonBox.vue?vue&type=template&id=38cf5baa&scoped=true&"
import script from "./MobileContactPersonBox.vue?vue&type=script&lang=js&"
export * from "./MobileContactPersonBox.vue?vue&type=script&lang=js&"
import style0 from "./MobileContactPersonBox.vue?vue&type=style&index=0&id=38cf5baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf5baa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VIcon,VImg,VSpacer})
